export default __webpack_public_path__ + "static/SML_logo-e45e1996abee61a7537f2efe14abee59.png";